import { FlexLayout, Text } from '@deity/falcon-ui';
import { Icon } from '@deity-io/portal-ui';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import type { PackageVersionType } from 'services/graphql/generated/schemas';
import { isPackageEditable } from 'utils/is-package-editable';

const VersionBadge: FC<{ packageVersionType: Partial<PackageVersionType> | undefined }> = ({ packageVersionType }) => {
  if (!packageVersionType) {
    return null;
  }

  const { packageUuid, uuid, version, status } = packageVersionType;

  return (
    <Link to={`/packages/${packageUuid}/${uuid}/package`} style={{ textDecoration: 'none' }}>
      <FlexLayout mr="xs" bg="badgeBg" alignItems="center" css={{ borderRadius: '4px', padding: '2px 10px' }}>
        <Text color="secondary" mr="xs" style={{ textTransform: 'uppercase' }}>
          Version
        </Text>
        <FlexLayout alignItems="center" color={isPackageEditable(status) ? 'green' : 'warning'}>
          <Icon icon={isPackageEditable(status) ? 'edit' : 'lock'} sx={{ fontSize: '20px' }} />
        </FlexLayout>
        <Text ml="xs" color="secondary" fontWeight="bold">
          {version}
        </Text>
      </FlexLayout>
    </Link>
  );
};

export default VersionBadge;
